<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER: 1-qator (sarlavha + jami qarzlar + Top) -->
      <div class="header-top">
        <h2 class="page-title">
          <b-icon icon="cash-coin" class="mr-2"></b-icon>Nasiyalar <span class="pt-sub">(Qarzlar)</span>
        </h2>
        <div class="header-summary">
          <div class="sum-card som">
            <span class="sum-lbl">Mijoz qarzi, so'm</span>
            <b class="sum-val">{{ formatMoney(totalDebtSom) }} <small>UZS</small></b>
          </div>
          <div class="sum-card dollar">
            <span class="sum-lbl">Mijoz qarzi, dollar</span>
            <b class="sum-val">{{ formatMoney(totalDebtDollar) }} <small>$</small></b>
          </div>
          <div class="sum-card our-som">
            <span class="sum-lbl">Bizning qarz, so'm</span>
            <b class="sum-val">{{ formatMoney(totalOurDebtSom) }} <small>UZS</small></b>
          </div>
          <div class="sum-card our-dollar">
            <span class="sum-lbl">Bizning qarz, dollar</span>
            <b class="sum-val">{{ formatMoney(totalOurDebtDollar) }} <small>$</small></b>
          </div>
          <button class="write-debt-btn" @click="openDebtModal()" title="Qo'lda qarz yozish">
            <b-icon icon="pencil-square" class="mr-1"></b-icon> Qarz yozish
          </button>
          <Top />
        </div>
      </div>

      <!-- HEADER: 2-qator (qidiruv + mijoz turi + qarzdorlar/barchasi) -->
      <div class="header-filters">
        <div class="search-box">
          <b-icon icon="search" class="search-icon"></b-icon>
          <input v-model="searchText" type="text" placeholder="Mijoz qidirish..." class="search-input" />
        </div>

        <!-- Mijoz turi bo'yicha filter -->
        <div class="type-filter">
          <button v-for="t in clientTypeDefs" :key="t.value"
            :class="['tf-btn', { active: typeFilter === t.value }]" @click="typeFilter = t.value">
            <b-icon :icon="t.icon"></b-icon> {{ t.label }}
            <span v-if="t.value !== 0" class="tf-count">{{ typeCount(t.value) }}</span>
          </button>
        </div>

        <!-- Toggle: faqat qarzdorlar / barchasi (tarix uchun) -->
        <div class="show-toggle">
          <button :class="['st-btn', !includeZero ? 'active' : '']" @click="setIncludeZero(false)">
            <b-icon icon="exclamation-circle"></b-icon> Faqat qarzdorlar
          </button>
          <button :class="['st-btn', includeZero ? 'active' : '']" @click="setIncludeZero(true)">
            <b-icon icon="clock-history"></b-icon> Barchasi (tarix)
          </button>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:55px">№</th>
                <th>MIJOZ NOMI</th>
                <th>TELEFON</th>
                <th>MANZIL</th>
                <th>TO'LOV SANASI</th>
                <th class="text-right">MIJOZ BIZGA QARZDOR</th>
                <th class="text-right">BIZ MIJOZGA QARZDOR</th>
                <th style="width:190px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in filteredDebtors" :key="item.id" class="debt-row clickable-row" @click="openDebtorSales(item)">
                <td><span class="id-badge">{{ index + 1 }}</span></td>

                <td>
                  <div class="name-cell">
                    <span class="font-bold text-dark">{{ item.name }}</span>
                    <span class="ct-badge" :class="'ct-' + (item.type || 1)">{{ clientTypeShort(item.type) }}</span>
                  </div>
                </td>

                <td>
                  <span class="phone-tag">{{ item.phone_number || '-' }}</span>
                </td>

                <td>
                  <span class="text-muted small">{{ item.address || '-' }}</span>
                </td>

                <td>
                  <span v-if="item.payment_date" :class="isOverdue(item.payment_date) ? 'tag red-tag' : 'tag green-tag'">
                    {{ formatPaymentDate(item.payment_date) }}
                    <span v-if="isOverdue(item.payment_date)"> (Muddati o'tgan)</span>
                  </span>
                  <span v-else class="text-muted small">-</span>
                </td>

                <td class="text-right">
                  <div v-if="Number(item.debt_som) > 0" class="debt-amount">
                    {{ formatMoney(item.debt_som) }} <span class="currency">UZS</span>
                  </div>
                  <div v-if="Number(item.debt_dollar) > 0" class="debt-amount dollar">
                    {{ formatMoney(item.debt_dollar) }} <span class="currency">$</span>
                  </div>
                  <span v-if="!hasClientDebt(item)" class="text-muted small">-</span>
                </td>

                <td class="text-right">
                  <div v-if="Number(item.our_debt_som) > 0" class="debt-amount our-debt">
                    {{ formatMoney(item.our_debt_som) }} <span class="currency">UZS</span>
                  </div>
                  <div v-if="Number(item.our_debt_dollar) > 0" class="debt-amount our-debt-dollar">
                    {{ formatMoney(item.our_debt_dollar) }} <span class="currency">$</span>
                  </div>
                  <span v-if="!hasOurDebt(item)" class="text-muted small">-</span>
                </td>

                <td>
                  <div class="debt-actions">
                    <button v-if="hasClientDebt(item)" class="pay-btn" @click.stop="openPayModal(item, 'client_owes')" title="Mijozdan to'lov olish">
                      <b-icon icon="box-arrow-in-down" class="mr-1"></b-icon> Qabul qilish
                    </button>
                    <button v-if="hasOurDebt(item)" class="pay-btn our-pay-btn" @click.stop="openPayModal(item, 'we_owe')" title="Mijozga qarzni to'lash">
                      <b-icon icon="box-arrow-up" class="mr-1"></b-icon> To'lash
                    </button>
                  </div>
                </td>
              </tr>

              <tr v-if="!loading && filteredDebtors.length === 0">
                <td colspan="8" class="empty-row">
                  <div class="py-5 text-center">
                    <p class="text-muted">{{ searchText ? 'Qidiruv natijasi topilmadi' : 'Nasiya yo\'q' }}</p>
                  </div>
                </td>
              </tr>

              <tr v-if="loading">
                <td colspan="8" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                </td>
              </tr>
            </tbody>

            <tfoot v-if="filteredDebtors.length > 0">
              <tr class="total-row">
                <td colspan="5" class="text-right font-bold">JAMI:</td>
                <td class="text-right">
                  <div class="debt-amount font-bold">{{ formatMoney(totalDebtSom) }} <span class="currency">UZS</span></div>
                  <div class="debt-amount dollar font-bold">{{ formatMoney(totalDebtDollar) }} <span class="currency">$</span></div>
                </td>
                <td class="text-right">
                  <div class="debt-amount our-debt font-bold">{{ formatMoney(totalOurDebtSom) }} <span class="currency">UZS</span></div>
                  <div class="debt-amount our-debt-dollar font-bold">{{ formatMoney(totalOurDebtDollar) }} <span class="currency">$</span></div>
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>

    <!-- SAVDOLAR RO'YXATI VA TARIX MODALI -->
    <div v-if="showSalesModal && selectedDebtor" class="modal-overlay" @click.self="closeSalesModal">
      <div class="sales-modal animate-pop">
        <div class="detail-header">
          <h3>{{ selectedDebtor.name }}</h3>
          <button class="close-btn" @click="closeSalesModal">&times;</button>
        </div>

        <div class="sales-info-bar">
          <span>Mijoz qarzi: <b class="red">{{ formatMoney(selectedDebtor.debt_som) }} UZS / {{ formatMoney(selectedDebtor.debt_dollar) }} $</b></span>
          <span>Bizning qarz: <b class="our-debt-text">{{ formatMoney(selectedDebtor.our_debt_som) }} UZS / {{ formatMoney(selectedDebtor.our_debt_dollar) }} $</b></span>
          <span>Tel: <b>{{ selectedDebtor.phone_number || '-' }}</b></span>
        </div>

        <!-- TAB BUTTONS -->
        <div class="tab-buttons">
          <button :class="['tab-btn', { active: activeTab === 'sales' }]" @click="activeTab = 'sales'">
            Savdolar
          </button>
          <button :class="['tab-btn', { active: activeTab === 'history' }]" @click="switchToHistory">
            Oldi-berdi tarixi
          </button>
        </div>

        <!-- SAVDOLAR TAB -->
        <div v-if="activeTab === 'sales'" class="sales-table-wrap">
          <table class="custom-table" v-if="debtorSales.length > 0">
            <thead>
              <tr>
                <th>№</th>
                <th>SANA</th>
                <th>JAMI</th>
                <th>TO'LANDI</th>
                <th>QARZ</th>
                <th style="width:150px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody v-for="s in debtorSales" :key="s.id">
              <tr :class="['clickable-row', { 'expanded': expandedSaleId === s.id }]">
                  <td><span class="id-badge">{{ s.id }}</span></td>
                  <td>{{ formatSaleDate(s.created_at) }}</td>
                  <td class="price blue">{{ formatMoney(s.summa) }}</td>
                  <td class="price green">{{ formatMoney(getSalePaid(s)) }}</td>
                  <td><span :class="getSaleDebt(s) > 0 ? 'price red' : 'price green'">{{ formatMoney(getSaleDebt(s)) }}</span></td>
                  <td class="text-center">
                    <div class="action-btns">
                      <button class="eye-btn" @click="toggleExpand(s.id)" :title="expandedSaleId === s.id ? 'Yopish' : 'Ko\'rish'">
                        <b-icon :icon="expandedSaleId === s.id ? 'eye-slash' : 'eye'"></b-icon>
                      </button>
                      <button v-if="getSaleDebt(s) > 0" class="pay-btn-sm" @click="openPayModalForSale(s)">
                        To'lash
                      </button>
                    </div>
                  </td>
                </tr>

                <!-- KENGAYTIRILGAN QATOR -->
                <tr v-if="expandedSaleId === s.id" class="detail-row">
                  <td colspan="6">
                    <div class="detail-container">
                      <!-- XIZMATLAR -->
                      <div v-if="hasServices(s)" class="detail-section">
                        <div class="detail-section-title purple">
                          <b-icon icon="gear" class="mr-1"></b-icon> Xizmatlar
                        </div>
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th>Nomi</th>
                              <th class="text-right">Ish haqi</th>
                              <th class="text-right">Peredelka</th>
                              <th class="text-right">Jami</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="pkg in getServices(s)" :key="'pkg-' + pkg.id">
                              <td>{{ pkg.name || (pkg.repair_package ? pkg.repair_package.name : '-') }}</td>
                              <td class="text-right">{{ formatMoney(packageLabor(s, pkg)) }}</td>
                              <td class="text-right">{{ formatMoney(packageRedo(s, pkg)) }}</td>
                              <td class="text-right font-bold">{{ formatMoney(packageLabor(s, pkg) + packageRedo(s, pkg)) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- MAHSULOTLAR -->
                      <div v-if="s.items && s.items.length > 0" class="detail-section">
                        <div class="detail-section-title blue">
                          <b-icon icon="box-seam" class="mr-1"></b-icon> Mahsulotlar
                        </div>
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th>Nomi</th>
                              <th class="text-right">Soni</th>
                              <th class="text-right">Narxi</th>
                              <th class="text-right">Summasi</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="itm in s.items" :key="'itm-' + itm.id">
                              <td>{{ itm.product ? (itm.product.extra_name || itm.product.name) : '-' }}</td>
                              <td class="text-right">{{ itm.count }}</td>
                              <td class="text-right">{{ formatMoney(itm.price) }}</td>
                              <td class="text-right font-bold">{{ formatMoney(itm.summa) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-if="!hasServices(s) && (!s.items || s.items.length === 0)" class="empty-detail">
                        Ma'lumot topilmadi
                      </div>
                    </div>
                  </td>
                </tr>
            </tbody>
          </table>
          <div v-else-if="salesLoading" class="text-center py-5">
            <b-spinner variant="primary"></b-spinner>
          </div>
          <div v-else class="text-center py-5 text-muted">Savdo topilmadi</div>
        </div>

        <!-- OLDI-BERDI TARIXI TAB -->
        <div v-if="activeTab === 'history'" class="sales-table-wrap">
          <table class="custom-table" v-if="paymentHistory.length > 0">
            <thead>
              <tr>
                <th>SANA</th>
                <th>HUJJAT TURI</th>
                <th>TO'LOV TURI</th>
                <th>VALYUTA</th>
                <th>TURI</th>
                <th class="text-right">SUMMA</th>
                <th>IZOH</th>
                <th style="width:70px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody v-for="h in paymentHistory" :key="h.id">
              <tr :class="[h.type === 1 ? 'history-kirim' : 'history-chiqim', { 'clickable-row': isSaleDoc(h), expanded: expandedHistoryId === h.id }]"
                @click="isSaleDoc(h) && toggleHistoryExpand(h)">
                <td>{{ formatSaleDate(h.datetime) }}</td>
                <td><span class="tag doc-tag">{{ docTypeLabel(h.doc_type) }}</span></td>
                <td>{{ h.pay_type || '-' }}</td>
                <td>
                  <span :class="['tag', h.currency === 'USD' ? 'usd-tag' : 'uzs-tag']">{{ h.currency }}</span>
                </td>
                <td>
                  <span :class="h.type === 1 ? 'tag green-tag' : 'tag red-tag'">
                    {{ h.type_name }}
                  </span>
                </td>
                <td class="text-right" :class="h.type === 1 ? 'price green' : 'price red'">
                  {{ h.type === 1 ? '+' : '-' }}{{ formatMoney(h.summa) }} {{ h.currency === 'USD' ? '$' : '' }}
                </td>
                <td class="text-muted small">{{ h.comment }}</td>
                <td class="text-center">
                  <div class="action-btns">
                    <button v-if="isSaleDoc(h)" class="eye-btn" @click.stop="toggleHistoryExpand(h)"
                      :title="expandedHistoryId === h.id ? 'Yopish' : 'Nima sotib olgan'">
                      <b-icon :icon="expandedHistoryId === h.id ? 'eye-slash' : 'eye'"></b-icon>
                    </button>
                    <button v-if="h.deletable" class="hist-del-btn" :disabled="historyLoading"
                      @click.stop="deleteHistoryItem(h)" title="O'chirish">
                      <b-icon icon="trash"></b-icon>
                    </button>
                  </div>
                </td>
              </tr>

              <!-- Shu to'lov/savdo yozuvi bilan bog'liq savdoda nima sotib olingani -->
              <tr v-if="expandedHistoryId === h.id" class="detail-row">
                <td colspan="8">
                  <div class="detail-container">
                    <div v-if="historyDetailLoading === h.id" class="text-center py-3">
                      <b-spinner variant="primary" small></b-spinner>
                    </div>
                    <template v-else-if="historyDetails[h.doc_id]">
                      <div v-if="hasServices(historyDetails[h.doc_id])" class="detail-section">
                        <div class="detail-section-title purple">
                          <b-icon icon="gear" class="mr-1"></b-icon> Xizmatlar
                        </div>
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th>Nomi</th>
                              <th class="text-right">Ish haqi</th>
                              <th class="text-right">Peredelka</th>
                              <th class="text-right">Jami</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="pkg in getServices(historyDetails[h.doc_id])" :key="'hpkg-' + pkg.id">
                              <td>{{ pkg.name || (pkg.repair_package ? pkg.repair_package.name : '-') }}</td>
                              <td class="text-right">{{ formatMoney(packageLabor(historyDetails[h.doc_id], pkg)) }}</td>
                              <td class="text-right">{{ formatMoney(packageRedo(historyDetails[h.doc_id], pkg)) }}</td>
                              <td class="text-right font-bold">{{ formatMoney(packageLabor(historyDetails[h.doc_id], pkg) + packageRedo(historyDetails[h.doc_id], pkg)) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-if="historyDetails[h.doc_id].items && historyDetails[h.doc_id].items.length > 0" class="detail-section">
                        <div class="detail-section-title blue">
                          <b-icon icon="box-seam" class="mr-1"></b-icon> Mahsulotlar
                        </div>
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th>Nomi</th>
                              <th class="text-right">Soni</th>
                              <th class="text-right">Narxi</th>
                              <th class="text-right">Summasi</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="itm in historyDetails[h.doc_id].items" :key="'hitm-' + itm.id">
                              <td>{{ itm.product ? (itm.product.extra_name || itm.product.name) : '-' }}</td>
                              <td class="text-right">{{ itm.count }}</td>
                              <td class="text-right">{{ formatMoney(itm.price) }}</td>
                              <td class="text-right font-bold">{{ formatMoney(itm.summa) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div v-if="!hasServices(historyDetails[h.doc_id]) && (!historyDetails[h.doc_id].items || historyDetails[h.doc_id].items.length === 0)" class="empty-detail">
                        Ma'lumot topilmadi
                      </div>
                    </template>
                    <div v-else class="empty-detail">Savdo topilmadi (o'chirilgan bo'lishi mumkin)</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else-if="historyLoading" class="text-center py-5">
            <b-spinner variant="primary"></b-spinner>
          </div>
          <div v-else class="text-center py-5 text-muted">Oldi-berdi tarixi topilmadi</div>
        </div>
      </div>
    </div>

    <!-- TO'LOV MODALI -->
    <div v-if="showPayModal && payDebtor" class="modal-overlay" @click.self="closePayModal">
      <div class="pay-modal animate-pop">
        <div class="detail-header">
          <h3>{{ payDirection === 'we_owe' ? "Qarzni to'lash" : "To'lovni qabul qilish" }} — {{ payDebtor.name }}</h3>
          <button class="close-btn" @click="closePayModal">&times;</button>
        </div>

        <div class="pay-info">
          <div class="pay-info-row">
            <span class="info-label">Mijoz:</span>
            <span class="font-bold">{{ payDebtor.name }}</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">{{ payDirection === 'we_owe' ? 'Bizning so\'m qarzimiz:' : 'Mijozning so\'m qarzi:' }}</span>
            <span class="font-bold red">{{ formatMoney(payDebtor.debt_som) }} UZS</span>
          </div>
          <div class="pay-info-row">
            <span class="info-label">{{ payDirection === 'we_owe' ? 'Bizning dollar qarzimiz:' : 'Mijozning dollar qarzi:' }}</span>
            <span class="font-bold red">{{ formatMoney(payDebtor.debt_dollar) }} $</span>
          </div>
        </div>

        <div class="pay-form">
          <!-- QAYSI QARZNI TO'LASH -->
          <div class="pay-field">
            <label>Qaysi qarzni hisoblash?</label>
            <div class="target-toggle">
              <button type="button" :class="['toggle-btn', { active: payTarget === 'som' }]" @click="payTarget = 'som'">
                So'm qarz
              </button>
              <button type="button" :class="['toggle-btn', { active: payTarget === 'dollar' }]" @click="payTarget = 'dollar'">
                Dollar qarz
              </button>
            </div>
          </div>

          <div class="method-grid">
            <div class="pay-field">
              <label>Naqd (so'm)</label>
              <summa-input v-model="payForm.cash_summa" input-class="pay-input" placeholder="0" />
            </div>
            <div class="pay-field">
              <label>Plastik (so'm)</label>
              <summa-input v-model="payForm.plastic_summa" input-class="pay-input" placeholder="0" />
            </div>
            <div class="pay-field">
              <label>Perechisleniye (so'm)</label>
              <summa-input v-model="payForm.shot_summa" input-class="pay-input" placeholder="0" />
            </div>
            <div class="pay-field">
              <label>Dollar (naqd $)</label>
              <summa-input v-model="payForm.dollar_summa" input-class="pay-input" placeholder="0" />
            </div>
            <div v-for="card in cardPayments" :key="card.pay_type_id" class="pay-field">
              <label>{{ card.name }} (so'm)</label>
              <summa-input v-model="card.summa" input-class="pay-input" placeholder="0" />
            </div>
          </div>
          <div v-if="payTypesError" class="conversion-note payment-error" role="alert">
            Karta turlarini yuklab bo'lmadi.
            <button type="button" class="qa-btn qa-soft" @click="fetchPayTypes">Qayta yuklash</button>
          </div>

          <div class="pay-field">
            <label>Dollar kursi (1$ = ? so'm)</label>
            <summa-input v-model="payForm.dollar_rate" input-class="pay-input" placeholder="0" />
          </div>

          <!-- KONVERTATSIYA OGOHLANTIRISH -->
          <div v-if="conversionNote" class="conversion-note">
            <b-icon icon="arrow-left-right" class="mr-1"></b-icon> {{ conversionNote }}
          </div>
          <div v-if="paymentExceedsDebt" class="conversion-note payment-error">
            To'lov qarz summasidan oshib ketmasligi kerak.
          </div>

          <!-- QUICK ACTIONS: qolgan summani avtomatik to'ldirish -->
          <div v-if="remainingTarget > 0" class="quick-actions">
            <div class="qa-label">
              <b-icon icon="lightning-charge-fill"></b-icon>
              <span>
                Qolgan qarz:
                <b :class="payTarget === 'dollar' ? 'green' : 'red'">
                  {{ formatMoney(remainingTarget) }} {{ payTarget === 'dollar' ? '$' : 'UZS' }}
                </b>
              </span>
            </div>
            <div class="qa-btns">
              <!-- Qolgan barchasini target valyutada to'lash -->
              <button type="button" class="qa-btn qa-primary" @click="quickPayAllRemainingInTargetCur">
                <b-icon icon="check-circle"></b-icon>
                Hammasini {{ payTarget === 'dollar' ? '$ naqd' : "so'm naqd" }}da to'lash
              </button>
              <!-- Lahtak: dollar qoldiq so'mga aylantirilsin -->
              <button v-if="payTarget === 'dollar'" type="button" class="qa-btn qa-soft"
                @click="quickPayLahtakDollarAsCashSom"
                :title="'≈ ' + formatMoney(lahtakDollarToSom) + ' soʼm'"
              >
                <b-icon icon="arrow-right-circle"></b-icon>
                Lahtakni naqd soʼmga ({{ formatMoney(lahtakDollarToSom) }} soʼm)
              </button>
              <!-- Aksincha: som qoldiq dollarga -->
              <button v-if="payTarget === 'som'" type="button" class="qa-btn qa-soft"
                @click="quickPayLahtakSomAsCashDollar"
                :title="'≈ ' + lahtakSomToDollar.toFixed(2) + ' $'"
              >
                <b-icon icon="arrow-right-circle"></b-icon>
                Lahtakni dollar naqdga ({{ lahtakSomToDollar.toFixed(2) }} $)
              </button>
              <!-- Tozalash -->
              <button type="button" class="qa-btn qa-clear" @click="quickClearPayFields" title="Maydonlarni tozalash">
                <b-icon icon="x-circle"></b-icon>
              </button>
            </div>
          </div>

          <div class="pay-field">
            <label>Izoh</label>
            <input type="text" v-model="payForm.comment" class="pay-input" placeholder="Izoh..." />
          </div>

          <div class="pay-total-row">
            <span>Qarzga hisoblanadi:</span>
            <span class="font-bold blue">
              {{ formatMoney(payReductionTarget) }} {{ payTarget === 'dollar' ? '$' : 'UZS' }}
            </span>
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closePayModal">BEKOR</button>
          <button class="m-btn pay-confirm" @click="submitPayment" :disabled="payInputTotal <= 0 || paymentExceedsDebt || payLoading">
            {{ payLoading ? 'Saqlanmoqda...' : (payDirection === 'we_owe' ? 'TO\'LASH' : 'QABUL QILISH') }}
          </button>
        </div>
      </div>
    </div>

    <!-- QO'LDA QARZ YOZISH MODALI -->
    <div v-if="showDebtModal" class="modal-overlay" @click.self="closeDebtModal">
      <div class="pay-modal animate-pop">
        <div class="detail-header">
          <h3>Qo'lda qarz yozish</h3>
          <button class="close-btn" @click="closeDebtModal">&times;</button>
        </div>

        <div class="pay-form">
          <!-- MIJOZ TANLASH -->
          <div class="pay-field" v-if="!debtForm.lockKontragent">
            <label>Mijoz</label>
            <input type="text" v-model="customerSearch" class="pay-input" placeholder="Mijoz qidirish..." @focus="customerDropdownOpen = true" />
            <div v-if="customerDropdownOpen && filteredCustomers.length > 0" class="customer-dropdown">
              <div v-for="c in filteredCustomers" :key="c.id" class="customer-option" @click="selectCustomer(c)">
                <span class="font-bold">{{ c.name }}</span>
                <span class="text-muted small">{{ c.phone_number || '' }}</span>
              </div>
            </div>
          </div>
          <div class="pay-field" v-else>
            <label>Mijoz</label>
            <div class="locked-customer">{{ debtForm.kontragent_name }}</div>
          </div>

          <div class="pay-field">
            <label>Kim qarzdor?</label>
            <div class="target-toggle">
              <button type="button" :class="['toggle-btn', { active: debtForm.direction === 'client_owes' }]" @click="debtForm.direction = 'client_owes'">
                Mijoz bizga qarzdor
              </button>
              <button type="button" :class="['toggle-btn', { active: debtForm.direction === 'we_owe' }]" @click="debtForm.direction = 'we_owe'">
                Biz mijozga qarzdor
              </button>
            </div>
          </div>

          <!-- VALYUTA -->
          <div class="pay-field">
            <label>Valyuta</label>
            <div class="target-toggle">
              <button type="button" :class="['toggle-btn', { active: debtForm.currency === 'som' }]" @click="debtForm.currency = 'som'">
                So'm
              </button>
              <button type="button" :class="['toggle-btn', { active: debtForm.currency === 'dollar' }]" @click="debtForm.currency = 'dollar'">
                Dollar
              </button>
            </div>
          </div>

          <div class="pay-field">
            <label>Qarz summasi ({{ debtForm.currency === 'dollar' ? '$' : 'so\'m' }})</label>
            <summa-input v-model="debtForm.summa" input-class="pay-input" placeholder="0" />
          </div>

          <div class="pay-field" v-if="debtForm.currency === 'dollar'">
            <label>Dollar kursi (ma'lumot uchun)</label>
            <summa-input v-model="debtForm.dollar_rate" input-class="pay-input" placeholder="0" />
          </div>

          <div class="pay-field">
            <label>Izoh</label>
            <input type="text" v-model="debtForm.comment" class="pay-input" placeholder="Izoh..." />
          </div>
        </div>

        <div class="pay-actions">
          <button class="m-btn cancel" @click="closeDebtModal">BEKOR</button>
          <button class="m-btn debt-confirm" @click="submitDebt" :disabled="!canSubmitDebt || debtLoading">
            {{ debtLoading ? 'Saqlanmoqda...' : 'QARZ YOZISH' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';

export default {
  name: 'NasiyalarIndex',
  components: { Top },
  data() {
    return {
      loading: false,
      debtors: [],
      searchText: '',
      // Mijoz turi filteri: 0 = barchasi, 1 = oddiy, 2 = usta, 3 = zapchas
      typeFilter: 0,
      clientTypeDefs: [
        { value: 0, label: 'Barchasi', icon: 'people-fill' },
        { value: 1, label: 'Oddiy',    icon: 'person-fill' },
        { value: 2, label: 'Usta',     icon: 'tools' },
        { value: 3, label: 'Zapchas',  icon: 'gear-fill' },
      ],
      // Toggle: false → faqat qarzdorlar (default), true → barchasi (qarzi 0 bo'lganlar ham)
      includeZero: false,
      dollarRate: 1,
      showSalesModal: false,
      salesLoading: false,
      historyLoading: false,
      selectedDebtor: null,
      debtorSales: [],
      expandedSaleId: null,
      paymentHistory: [],
      // "Oldi-berdi tarixi" tabida savdo qatorini kengaytirib, shu savdodagi
      // mahsulot/xizmatlarni ko'rsatish uchun
      expandedHistoryId: null,
      historyDetails: {}, // { [service_sale.id]: sale detail }
      historyDetailLoading: null,
      activeTab: 'sales',
      // To'lov modali
      showPayModal: false,
      payLoading: false,
      payDebtor: null,
      payDirection: 'client_owes',
      payTarget: 'som',
      payTargetSaleId: null, // savdo yonidagi "To'lash" — o'sha savdoni birinchi yopish uchun
      cardPayments: [],
      payTypesError: false,
      payForm: { cash_summa: 0, plastic_summa: 0, shot_summa: 0, dollar_summa: 0, dollar_rate: 1, comment: '' },
      // Qo'lda qarz modali
      showDebtModal: false,
      debtLoading: false,
      debtForm: { kontragent_id: null, kontragent_name: '', summa: 0, currency: 'som', direction: 'client_owes', dollar_rate: 1, comment: '', lockKontragent: false },
      customers: [],
      customerSearch: '',
      customerDropdownOpen: false,
    };
  },
  computed: {
    // Mijoz turi bo'yicha (filterdan oldin — type tugmalaridagi sonlar uchun)
    typeFilteredDebtors() {
      if (!this.typeFilter) return this.debtors;
      return this.debtors.filter(d => Number(d.type || 1) === this.typeFilter);
    },
    filteredDebtors() {
      let list = this.typeFilteredDebtors;
      if (this.searchText) {
        const q = this.searchText.toLowerCase();
        list = list.filter(d =>
          (d.name || '').toLowerCase().includes(q) ||
          (d.phone_number || '').includes(q)
        );
      }
      return list;
    },
    totalDebtSom() {
      return this.filteredDebtors.reduce((s, d) => s + Number(d.debt_som || 0), 0);
    },
    totalDebtDollar() {
      return this.filteredDebtors.reduce((s, d) => s + Number(d.debt_dollar || 0), 0);
    },
    totalOurDebtSom() {
      return this.filteredDebtors.reduce((s, d) => s + Number(d.our_debt_som || 0), 0);
    },
    totalOurDebtDollar() {
      return this.filteredDebtors.reduce((s, d) => s + Number(d.our_debt_dollar || 0), 0);
    },
    // So'm to'lov usullari yig'indisi
    paySomMethods() {
      return Number(this.payForm.cash_summa || 0) + Number(this.payForm.plastic_summa || 0) + Number(this.payForm.shot_summa || 0)
        + this.cardPayments.reduce((total, card) => total + Number(card.summa || 0), 0);
    },
    payDollarMethod() {
      return Number(this.payForm.dollar_summa || 0);
    },
    payInputTotal() {
      return this.paySomMethods + this.payDollarMethod;
    },
    // Tanlangan qarz valyutasida hisoblanadigan pasayish (backend #add bilan bir xil)
    payReductionTarget() {
      const rate = Number(this.payForm.dollar_rate || 1) || 1;
      if (this.payTarget === 'dollar') {
        // dollar qarz: so'm to'lovlar / kurs + dollar to'lov
        return this.paySomMethods / rate + this.payDollarMethod;
      }
      // so'm qarz: so'm to'lovlar + dollar to'lov * kurs
      return this.paySomMethods + this.payDollarMethod * rate;
    },
    conversionNote() {
      const rate = Number(this.payForm.dollar_rate || 1) || 1;
      if (this.payTarget === 'som' && this.payDollarMethod > 0) {
        return `Dollar to'lov so'm qarzga ${this.formatMoney(rate)} kursida hisoblanadi (${this.formatMoney(this.payDollarMethod * rate)} so'm).`;
      }
      if (this.payTarget === 'dollar' && this.paySomMethods > 0) {
        return `So'm to'lov dollar qarzga ${this.formatMoney(rate)} kursida konvertatsiya qilinadi (${this.formatMoney(this.paySomMethods / rate)} $).`;
      }
      return '';
    },
    // Joriy tab uchun qancha qarz qolgan (target valyutada)
    currentTargetDebt() {
      if (!this.payDebtor) return 0;
      return this.payTarget === 'dollar'
        ? Number(this.payDebtor.debt_dollar || 0)
        : Number(this.payDebtor.debt_som || 0);
    },
    // Hozir kiritilgan to'lov target valyutada qancha qarzni qoplamoqda (=payReductionTarget)
    // Qolgan to'lanmagan qism (target valyutada)
    remainingTarget() {
      const left = this.currentTargetDebt - this.payReductionTarget;
      return left > 0.01 ? left : 0;
    },
    paymentExceedsDebt() {
      return this.payReductionTarget > this.currentTargetDebt + 0.005;
    },
    // Lahtak: dollar qarz tabida, hozir kiritilgan $X dan tashqari qoldiq $Y bor
    //   → uni so'mga aylantirsak qancha bo'ladi
    lahtakDollarToSom() {
      const rate = Number(this.payForm.dollar_rate || 1) || 1;
      if (this.payTarget !== 'dollar') return 0;
      return this.remainingTarget * rate;
    },
    // Aksincha: so'm qarz qolib qolsa, dollar'ga aylantirsak qancha
    lahtakSomToDollar() {
      const rate = Number(this.payForm.dollar_rate || 1) || 1;
      if (this.payTarget !== 'som') return 0;
      return rate > 0 ? this.remainingTarget / rate : 0;
    },
    filteredCustomers() {
      const q = (this.customerSearch || '').toLowerCase();
      const list = this.customers;
      if (!q) return list.slice(0, 30);
      return list.filter(c =>
        (c.name || '').toLowerCase().includes(q) ||
        (c.phone_number || '').includes(q)
      ).slice(0, 30);
    },
    canSubmitDebt() {
      return !!this.debtForm.kontragent_id && Number(this.debtForm.summa) > 0;
    },
  },
  async mounted() {
    this.fetchPayTypes();
    await this.fetchDebtors();
    this.fetchDollarRate();
    // Boshqa sahifadagi (masalan Mijozlar) qarz bildirishnomasidan kelganda
    // shu mijozning oldi-berdi tarixi oynasini to'g'ridan-to'g'ri ochib yuboradi.
    const qId = parseInt(this.$route.query.kontragent_id);
    if (qId) await this.openDebtorById(qId);
  },
  methods: {
    setIncludeZero(val) {
      if (this.includeZero === val) return;
      this.includeZero = val;
      this.fetchDebtors();
    },
    // Mijoz turi yorlig'i (qisqa) — jadval badge'i uchun
    clientTypeShort(type) {
      const map = { 1: 'Oddiy', 2: 'Usta', 3: 'Zapchas' };
      return map[Number(type)] || 'Oddiy';
    },
    // Filter tugmasidagi son (har bir turdagi qarzdorlar soni)
    typeCount(type) {
      return this.debtors.filter(d => Number(d.type || 1) === type).length;
    },
    async fetchDebtors() {
      this.loading = true;
      try {
        const params = {};
        if (this.includeZero) params.include_zero = 1;
        const res = await axios.get('api/v1/kontragent/debtors', { params });
        const list = Array.isArray(res.data) ? res.data : [];
        this.debtors = list.map(d => ({
          ...d,
          debt_som: Number(d.debt_som || 0),
          debt_dollar: Number(d.debt_dollar || 0),
          our_debt_som: Number(d.our_debt_som || 0),
          our_debt_dollar: Number(d.our_debt_dollar || 0),
        }));
      } catch (e) {
        console.error('Nasiyalarni yuklashda xato:', e);
        this.debtors = [];
      } finally {
        this.loading = false;
      }
    },
    async fetchDollarRate() {
      try {
        const res = await axios.get('api/v1/dollar-exchange-rate/last');
        const rate = Number(res.data?.rate || res.data || 0);
        if (rate > 0) this.dollarRate = rate;
      } catch (e) {
        // kurs topilmasa 1 qoladi
        console.warn('Dollar kursini yuklab bo\'lmadi');
      }
    },
    formatMoney(v) {
      if (!v || v === 0) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/ /g, ' ');
    },
    hasClientDebt(item) {
      return Number(item && item.debt_som || 0) > 0 || Number(item && item.debt_dollar || 0) > 0;
    },
    hasOurDebt(item) {
      return Number(item && item.our_debt_som || 0) > 0 || Number(item && item.our_debt_dollar || 0) > 0;
    },
    formatPaymentDate(ts) {
      if (!ts) return '-';
      const date = new Date(Number(ts) * 1000);
      return date.toLocaleDateString('ru-RU');
    },
    formatSaleDate(ts) {
      if (!ts) return '-';
      return this.$formatDate(ts);
    },
    docTypeLabel(t) {
      const map = {
        kirim: 'Kirim faktura',
        chiqim: 'Sotuv',
        tolov: "To'lov",
        service_sale: 'Xizmat',
        service_sale_refund: 'Xizmat qaytarish',
        manual_debt: "Qo'lda qarz",
        refund: 'Qaytarish',
        initial_balance: 'Boshlang\'ich',
      };
      return map[t] || t || '-';
    },
    isOverdue(paymentDate) {
      if (!paymentDate) return false;
      const now = Math.floor(Date.now() / 1000);
      return Number(paymentDate) < now;
    },
    getSalePaid(s) {
      if (!s) return 0;
      const rate = parseFloat(s.dollar_rate) || 1;
      // pay_table ustuvor (dollar qatorlari kurs bo'yicha so'mga aylantiriladi)
      if (Array.isArray(s.pay_table) && s.pay_table.length > 0) {
        return s.pay_table.reduce((acc, row) => {
          const v = parseFloat(row.summa) || 0;
          if (v <= 0) return acc;
          return acc + (parseInt(row.pay_type_id) === 3 ? v * rate : v);
        }, 0);
      }
      // Legacy fallback
      return Number(s.cash_summa || 0) + Number(s.plastic_summa || 0)
        + Number(s.shot_summa || 0) + Number(s.dollar_summa || 0) * rate;
    },
    getSaleDebt(s) {
      return Math.max(0, Number(s.summa || 0) - this.getSalePaid(s));
    },
    toggleExpand(id) {
      this.expandedSaleId = this.expandedSaleId === id ? null : id;
    },
    // "Oldi-berdi tarixi"dagi qaysi qatorlar savdoga tegishli ekanini aniqlaydi
    // (faqat shundaylarida "nima sotib olgan" ko'rsatish mumkin)
    isSaleDoc(h) {
      return h.doc_type === 'Хизмат кўрсатиш' && !!h.doc_id;
    },
    async toggleHistoryExpand(h) {
      if (this.expandedHistoryId === h.id) {
        this.expandedHistoryId = null;
        return;
      }
      this.expandedHistoryId = h.id;
      if (!this.historyDetails[h.doc_id]) {
        this.historyDetailLoading = h.id;
        try {
          const res = await axios.get(`api/v1/service-sale/id/${h.doc_id}`);
          this.$set(this.historyDetails, h.doc_id, res.data);
        } catch (e) {
          console.error('Savdo tafsilotini yuklashda xato:', e);
          this.$set(this.historyDetails, h.doc_id, null);
        } finally {
          this.historyDetailLoading = null;
        }
      }
    },
    getSaleType(s) {
      return (s && s.price_type) || (s && s.sale_type) || (s && s.kontragent && s.kontragent.sale_type) || 'chakana';
    },
    hasServices(s) {
      if (!s) return false;
      if (s.packages && s.packages.length > 0) return true;
      if (s.repair_package) return true;
      return false;
    },
    getServices(s) {
      if (!s) return [];
      if (s.packages && s.packages.length > 0) return s.packages;
      if (s.repair_package) return [{ ...s.repair_package, id: s.repair_package.id, _single: true }];
      return [];
    },
    packageLabor(sale, pkg) {
      const type = this.getSaleType(sale);
      const src = pkg._single ? sale : pkg;
      return type === 'optom' ? Number(src.labor_price_optom || 0) : Number(src.labor_price_chakana || 0);
    },
    packageRedo(sale, pkg) {
      const type = this.getSaleType(sale);
      const src = pkg._single ? sale : pkg;
      return type === 'optom' ? Number(src.redo_price_optom || 0) : Number(src.redo_price_chakana || 0);
    },
    // debt-alerts (Mijozlar) ro'yxati va shu sahifadagi "qarzdorlar" ro'yxati
    // boshqa-boshqa mezon bilan hisoblanadi — mijoz shu yerdagi ro'yxatda
    // bo'lmasligi mumkin. Shuning uchun aynan shu ID bo'yicha to'g'ridan-to'g'ri
    // ochamiz: avval mavjud ro'yxatdan qidiramiz, topilmasa mijozni alohida
    // yuklab olamiz — har holda tarix shu mijozniki chiqishi kerak.
    async openDebtorById(id) {
      let debtor = this.debtors.find(d => Number(d.id) === Number(id));
      if (!debtor) {
        try {
          const res = await axios.get(`api/v1/kontragent/id/${id}`);
          debtor = {
            id: res.data.id,
            name: res.data.name,
            phone_number: res.data.phone_number,
            type: res.data.type,
            debt_som: 0, debt_dollar: 0, our_debt_som: 0, our_debt_dollar: 0,
          };
        } catch (e) {
          console.error('Mijozni topishda xato:', e);
          return;
        }
      }
      await this.openDebtorSales(debtor, 'history');
    },
    async openDebtorSales(debtor, forceTab) {
      this.selectedDebtor = debtor;
      this.debtorSales = [];
      this.showSalesModal = true;
      this.activeTab = forceTab || (this.hasClientDebt(debtor) ? 'sales' : 'history');
      this.paymentHistory = [];
      this.expandedHistoryId = null;
      this.historyDetails = {};
      if (this.activeTab === 'sales') await this.loadDebtorSales();
      else await this.loadPaymentHistory();
    },
    // Savdolar ro'yxatini qayta yuklash (tabni o'zgartirmaydi)
    async loadDebtorSales() {
      if (!this.selectedDebtor) return;
      this.salesLoading = true;
      try {
        const res = await axios.get('api/v1/service-sale', {
          params: { kontragent_id: this.selectedDebtor.id }
        });
        // To'liq oldi-berdi: barcha savdolar (faqat qarzlilar emas)
        this.debtorSales = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error('Savdolarni yuklashda xato:', e);
        this.debtorSales = [];
      } finally {
        this.salesLoading = false;
      }
    },
    closeSalesModal() {
      this.showSalesModal = false;
      this.selectedDebtor = null;
      this.debtorSales = [];
      this.paymentHistory = [];
      this.activeTab = 'sales';
      if (this.$route.query.kontragent_id) {
        this.$router.replace({ query: {} }).catch(() => {});
      }
    },
    async switchToHistory() {
      this.activeTab = 'history';
      if (this.paymentHistory.length > 0) return;
      await this.loadPaymentHistory();
    },
    async loadPaymentHistory() {
      if (!this.selectedDebtor) return;
      this.historyLoading = true;
      try {
        const res = await axios.get(`api/v1/kontragent/payment-history/${this.selectedDebtor.id}`);
        this.paymentHistory = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error('Tarix yuklashda xato:', e);
        this.paymentHistory = [];
      } finally {
        this.historyLoading = false;
      }
    },
    // Oldi-berdi tarixidan to'lov/qo'lda qarzni o'chirish (to'lov bo'lsa kassadan ham tozalanadi)
    async deleteHistoryItem(h) {
      if (!h || !h.deletable) return;
      const ok = window.confirm(
        h.kind === 'payment'
          ? "To'lov o'chirilsinmi? Kassadan ham olib tashlanadi va savdo qarzi qayta tiklanadi."
          : "Qo'lda yozilgan qarz o'chirilsinmi?"
      );
      if (!ok) return;
      this.historyLoading = true;
      try {
        if (h.kind === 'payment') {
          await axios.delete(`api/v1/kontragent-pay/id/${h.doc_id}`);
        } else if (h.kind === 'manual_debt') {
          await axios.delete(`api/v1/kontragent/manual-debt/${h.id}`);
        } else {
          this.historyLoading = false;
          return;
        }
        // Tarix, savdolar va qarzdorlar ro'yxatini yangilaymiz (tabni o'zgartirmasdan)
        await this.loadPaymentHistory();
        await this.loadDebtorSales();
        this.fetchDebtors();
      } catch (e) {
        console.error("O'chirish xatosi:", e);
        this.$store.state.errors = (e.response && e.response.data && (e.response.data.message || e.response.data))
          || "O'chirishda xatolik";
      } finally {
        this.historyLoading = false;
      }
    },
    // ===================== TO'LOV =====================
    async fetchPayTypes() {
      this.payTypesError = false;
      try {
        const { data } = await axios.get('api/v1/pay-type');
        this.cardPayments = data.filter(t => Number(t.id) > 4).map(t => ({
          pay_type_id: Number(t.id),
          name: t.name,
          summa: (this.cardPayments.find(c => c.pay_type_id === Number(t.id)) || {}).summa || 0,
        }));
      } catch (e) {
        this.payTypesError = true;
      }
    },
    openPayModal(debtor, direction = 'client_owes') {
      this.cardPayments.forEach(card => { card.summa = 0; });
      const ourDebt = direction === 'we_owe';
      const som = Number(ourDebt ? debtor.our_debt_som : debtor.debt_som) || 0;
      const dollar = Number(ourDebt ? debtor.our_debt_dollar : debtor.debt_dollar) || 0;
      this.payTargetSaleId = null; // mijoz darajasidagi to'lov — sof FIFO
      this.payDirection = direction;
      this.payDebtor = { ...debtor, kontragent_id: debtor.id, debt_som: som, debt_dollar: dollar };
      this.payTarget = som > 0 ? 'som' : (dollar > 0 ? 'dollar' : 'som');
      this.payForm = {
        cash_summa: 0, plastic_summa: 0, shot_summa: 0, dollar_summa: 0,
        dollar_rate: this.dollarRate,
        comment: ourDebt ? `${debtor.name}ga qarz to'lovi` : `${debtor.name} qarz to'lovi`,
      };
      this.showPayModal = true;
    },
    openPayModalForSale(sale) {
      this.cardPayments.forEach(card => { card.summa = 0; });
      const d = this.selectedDebtor || {};
      this.payDirection = 'client_owes';
      this.payTargetSaleId = sale.id; // shu savdoni birinchi yopadi
      this.payDebtor = {
        ...d,
        kontragent_id: d.id,
        debt_som: Number(d.debt_som || 0),
        debt_dollar: Number(d.debt_dollar || 0),
      };
      this.payTarget = Number(d.debt_som || 0) > 0 ? 'som' : (Number(d.debt_dollar || 0) > 0 ? 'dollar' : 'som');
      this.payForm = {
        cash_summa: 0, plastic_summa: 0, shot_summa: 0, dollar_summa: 0,
        dollar_rate: this.dollarRate,
        comment: `Savdo #${sale.id} uchun to'lov`,
      };
      this.showPayModal = true;
    },
    closePayModal() {
      this.showPayModal = false;
      this.payDebtor = null;
    },

    // =========== QUICK ACTIONS (lahtak universal yopish) ===========
    // Qolgan barcha qarzni mos valyutada to'liq to'lash
    quickPayAllRemainingInTargetCur() {
      const remaining = this.remainingTarget;
      if (remaining <= 0) return;
      if (this.payTarget === 'dollar') {
        this.payForm.dollar_summa = Number(this.payForm.dollar_summa || 0) + remaining;
      } else {
        this.payForm.cash_summa = Number(this.payForm.cash_summa || 0) + remaining;
      }
    },
    // Lahtak (qoldiq) dollar qarzni so'm naqd qilib avtomatik to'lash
    quickPayLahtakDollarAsCashSom() {
      const remDollar = this.remainingTarget;
      if (remDollar <= 0 || this.payTarget !== 'dollar') return;
      const rate = Number(this.payForm.dollar_rate || 1) || 1;
      const addSom = remDollar * rate;
      // Yumaloqlash: 100 so'mgacha (lahtakni toza ko'rsatish)
      const rounded = Math.round(addSom / 100) * 100;
      this.payForm.cash_summa = Number(this.payForm.cash_summa || 0) + rounded;
    },
    // Lahtak (qoldiq) so'm qarzni dollar naqd qilish
    quickPayLahtakSomAsCashDollar() {
      const remSom = this.remainingTarget;
      if (remSom <= 0 || this.payTarget !== 'som') return;
      const rate = Number(this.payForm.dollar_rate || 1) || 1;
      if (rate <= 0) return;
      const addDollar = remSom / rate;
      // 0.5 $ ga yumaloqlash
      const rounded = Math.round(addDollar * 2) / 2;
      this.payForm.dollar_summa = Number(this.payForm.dollar_summa || 0) + rounded;
    },
    // To'lov maydonlarini tozalash
    quickClearPayFields() {
      this.cardPayments.forEach(card => { card.summa = 0; });
      this.payForm.cash_summa = 0;
      this.payForm.plastic_summa = 0;
      this.payForm.shot_summa = 0;
      this.payForm.dollar_summa = 0;
    },
    async submitPayment() {
      if (this.payInputTotal <= 0 || !this.payDebtor || this.paymentExceedsDebt) return;
      this.payLoading = true;
      try {
        const sklad_id = Number(localStorage.getItem('sklad_id'));
        const kontragent_id = this.payDebtor.kontragent_id || this.payDebtor.id;
        const numberRes = await axios.get('api/v1/kontragent-pay/last-number');
        const number = numberRes.data?.number || numberRes.data || 1;
        const datetime = Math.floor(Date.now() / 1000);
        const rate = Number(this.payForm.dollar_rate || 1) || 1;
        const pay_type_id = this.payTarget === 'dollar' ? 3 : 1;

        // konvertatsiya holatida izohni avtomatik to'ldirish
        let comment = this.payForm.comment || '';
        if (this.payTarget === 'som' && this.payDollarMethod > 0 && !comment) {
          comment = "Dollar qarz to'landi";
        }

        await axios.post('api/v1/kontragent-pay', {
          datetime,
          sklad_id,
          kontragent_id,
          summa: this.payReductionTarget,
          current_total: 0,
          current_total_dollar: 0,
          pay_type_id,
          type: this.payDirection === 'client_owes',
          number,
          dollar_rate: rate,
          pay_type_kassa: 1,
          kassa_summa: 0,
          cash_summa: Number(this.payForm.cash_summa || 0),
          plastic_summa: Number(this.payForm.plastic_summa || 0),
          shot_summa: Number(this.payForm.shot_summa || 0),
          dollar_summa: Number(this.payForm.dollar_summa || 0),
          pay_table: [
            { pay_type_id: 1, summa: Number(this.payForm.cash_summa || 0) },
            { pay_type_id: 2, summa: Number(this.payForm.plastic_summa || 0) },
            { pay_type_id: 4, summa: Number(this.payForm.shot_summa || 0) },
            { pay_type_id: 3, summa: Number(this.payForm.dollar_summa || 0) },
            ...this.cardPayments.map(card => ({ pay_type_id: card.pay_type_id, summa: Number(card.summa || 0) })),
          ].filter(row => row.summa > 0),
          qaytim_som: 0,
          qaytim_dollar: 0,
          comment,
          target_service_sale_id: this.payTargetSaleId || null,
        });

        this.closePayModal();
        if (this.showSalesModal && this.selectedDebtor) {
          this.paymentHistory = [];
          await this.openDebtorSales(this.selectedDebtor);
        } else {
          this.closeSalesModal();
        }
        this.fetchDebtors();
      } catch (e) {
        console.error('To\'lov xatosi:', e);
        alert("To'lovda xatolik yuz berdi");
      } finally {
        this.payLoading = false;
      }
    },
    // ===================== QO'LDA QARZ =====================
    async openDebtModal(debtor = null) {
      this.debtForm = {
        kontragent_id: debtor ? debtor.id : null,
        kontragent_name: debtor ? debtor.name : '',
        summa: 0,
        currency: 'som',
        direction: 'client_owes',
        dollar_rate: this.dollarRate,
        comment: '',
        lockKontragent: !!debtor,
      };
      this.customerSearch = '';
      this.customerDropdownOpen = false;
      this.showDebtModal = true;
      if (this.customers.length === 0) {
        await this.fetchCustomers();
      }
    },
    async fetchCustomers() {
      try {
        // Barcha mijoz turlari (oddiy + usta + zapchas) — qo'lda qarz har qaysisiga yozilsin
        const res = await axios.get('api/v1/kontragent/');
        this.customers = Array.isArray(res.data) ? res.data : ((res.data && res.data.data) || []);
      } catch (e) {
        console.error('Mijozlarni yuklashda xato:', e);
        this.customers = [];
      }
    },
    selectCustomer(c) {
      this.debtForm.kontragent_id = c.id;
      this.debtForm.kontragent_name = c.name;
      this.customerSearch = c.name;
      this.customerDropdownOpen = false;
    },
    closeDebtModal() {
      this.showDebtModal = false;
    },
    async submitDebt() {
      if (!this.canSubmitDebt) return;
      this.debtLoading = true;
      try {
        const datetime = Math.floor(Date.now() / 1000);
        await axios.post('api/v1/kontragent/manual-debt', {
          kontragent_id: this.debtForm.kontragent_id,
          summa: Number(this.debtForm.summa),
          currency: this.debtForm.currency,
          direction: this.debtForm.direction,
          dollar_rate: Number(this.debtForm.dollar_rate || 1),
          comment: this.debtForm.comment || (this.debtForm.direction === 'we_owe'
            ? "Bizning qo'lda yozilgan qarzimiz"
            : "Mijozning qo'lda yozilgan qarzi"),
          datetime,
        });
        this.closeDebtModal();
        this.fetchDebtors();
        if (this.showSalesModal && this.selectedDebtor) {
          this.paymentHistory = [];
          if (this.activeTab === 'history') this.switchToHistory();
        }
      } catch (e) {
        console.error('Qarz yozishda xato:', e);
        alert("Qarz yozishda xatolik yuz berdi");
      } finally {
        this.debtLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  /* Layout topbar (56px) ni hisobga olamiz — aks holda sahifa pasti ekran ortiga chiqib ketadi */
  height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;
}

.content-container {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* HEADER: 1-qator */
.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.page-title {
  color: #e11d48;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
  display: inline-flex;
  align-items: center;
}
.page-title .pt-sub { color: #94a3b8; font-weight: 600; font-size: 16px; margin-left: 6px; }

.header-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Jami qarz kartalari */
.sum-card {
  display: flex;
  flex-direction: column;
  padding: 6px 18px;
  border-radius: 14px;
  min-width: 130px;
  border: 1px solid transparent;
}
.sum-card .sum-lbl { font-size: 11px; font-weight: 700; text-transform: uppercase; opacity: 0.8; }
.sum-card .sum-val { font-size: 18px; font-weight: 800; }
.sum-card .sum-val small { font-size: 11px; font-weight: 600; opacity: 0.7; }
.sum-card.som { background: #fff1f2; color: #e11d48; border-color: #fecdd3; }
.sum-card.dollar { background: #ecfeff; color: #0891b2; border-color: #a5f3fc; }
.sum-card.our-som { background: #eff6ff; color: #2563eb; border-color: #bfdbfe; }
.sum-card.our-dollar { background: #f0fdf4; color: #15803d; border-color: #bbf7d0; }

/* HEADER: 2-qator (filtrlar) */
.header-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

/* Mijoz turi filter */
.type-filter {
  display: inline-flex;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
  gap: 3px;
}
.tf-btn {
  background: transparent;
  border: none;
  padding: 8px 14px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: 0.18s;
  white-space: nowrap;
}
.tf-btn:hover:not(.active) { color: #e11d48; background: rgba(255,255,255,0.7); }
.tf-btn.active {
  background: linear-gradient(135deg, #e11d48 0%, #be123c 100%);
  color: white;
  box-shadow: 0 3px 8px rgba(225,29,72,0.25);
}
.tf-count {
  background: rgba(0,0,0,0.08);
  color: inherit;
  font-size: 11px;
  font-weight: 800;
  padding: 1px 7px;
  border-radius: 999px;
  min-width: 18px;
  text-align: center;
}
.tf-btn.active .tf-count { background: rgba(255,255,255,0.25); }

/* Mijoz nomi + turi badge */
.name-cell { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.ct-badge {
  font-size: 10px;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.ct-1 { background: #f5f3ff; color: #7c3aed; }
.ct-2 { background: #eff6ff; color: #2563eb; }
.ct-3 { background: #fff7ed; color: #ea580c; }

.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}

.search-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 12px 0 36px;
  font-size: 14px;
  outline: none;
  background: white;
  width: 220px;
}

.total-badge {
  background: #fff1f2;
  color: #e11d48;
  border: 1px solid #fecdd3;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
}

/* Toggle: faqat qarzdorlar / barchasi */
.show-toggle {
  display: inline-flex;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}
.st-btn {
  background: transparent;
  border: none;
  padding: 7px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: 0.2s;
  white-space: nowrap;
}
.st-btn:hover:not(.active) { color: #a142f4; background: rgba(255, 255, 255, 0.6); }
.st-btn.active {
  background: white;
  color: #0f172a;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.dollar-badge {
  background: #ecfeff;
  color: #0891b2;
  border-color: #a5f3fc;
}

.write-debt-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border: none;
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.write-debt-btn:hover { filter: brightness(0.95); }

.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.table-wrapper {
  overflow-y: auto;
  flex-grow: 1;
}

.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 14px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
}

.custom-table td {
  padding: 14px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.debt-row:hover td {
  background: #fff5f5;
}

.total-row td {
  padding: 14px 15px;
  background: #fff1f2;
  border-top: 2px solid #fecdd3;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}

.phone-tag {
  color: #2563eb;
  font-weight: 600;
}

.tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.red-tag   { background: #fff1f2; color: #e11d48; }
.green-tag { background: #ecfdf5; color: #10b981; }
.usd-tag   { background: #ecfeff; color: #0891b2; }
.uzs-tag   { background: #f1f5f9; color: #64748b; }

.debt-amount {
  color: #e11d48;
  font-weight: 800;
  font-size: 16px;
}
.debt-amount.dollar { color: #0891b2; }
.debt-amount.our-debt { color: #2563eb; }
.debt-amount.our-debt-dollar { color: #15803d; }
.our-debt-text { color: #2563eb; }

.currency {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
}

.text-muted { color: #94a3b8; }
.small      { font-size: 12px; }
.font-bold  { font-weight: 700; }
.text-dark  { color: #1e293b; }
.text-right { text-align: right; }
.text-center { text-align: center; }
.blue  { color: #2563eb; }
.green { color: #10b981; }
.red   { color: #e11d48; }
.price { font-weight: 700; }

.clickable-row { cursor: pointer; transition: background 0.15s; }
.clickable-row:hover { background: #fff5f5; }

.pay-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.debt-actions {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}
.our-pay-btn {
  background: #2563eb;
}
.payment-error {
  color: #b91c1c;
  background: #fef2f2;
  border-color: #fecaca;
}

.pay-btn-sm {
  background: #fef3c7;
  color: #d97706;
  border: none;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 11px;
  cursor: pointer;
}
.pay-btn-sm:hover {
  background: #d97706;
  color: white;
}

.action-btns {
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
}
.eye-btn {
  width: 30px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: #eff6ff;
  color: #2563eb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.eye-btn:hover {
  background: #2563eb;
  color: white;
  transform: scale(1.05);
}

.clickable-row.expanded td {
  background: #fafbff;
}

/* Tarixdagi o'chirish tugmasi */
.hist-del-btn {
  width: 30px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: #fff1f2;
  color: #e11d48;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.hist-del-btn:hover:not(:disabled) {
  background: #e11d48;
  color: white;
  transform: scale(1.05);
}
.hist-del-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* MODAL OVERLAY */
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(15,23,42,0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.animate-pop {
  animation: pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes pop {
  0%   { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1);   opacity: 1; }
}

/* SALES MODAL */
.sales-modal {
  background: white;
  border-radius: 24px;
  width: 760px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #f1f5f9;
}

.detail-header h3 {
  margin: 0;
  font-size: 18px;
  color: #1e293b;
}

.close-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  font-size: 22px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover { background: #e2e8f0; }

.sales-info-bar {
  display: flex;
  justify-content: space-between;
  padding: 12px 25px;
  background: #fff1f2;
  font-size: 14px;
  gap: 12px;
  flex-wrap: wrap;
}

.tab-buttons {
  display: flex;
  padding: 0 25px;
  gap: 8px;
  border-bottom: 1px solid #f1f5f9;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background: none;
  font-weight: 700;
  font-size: 13px;
  color: #94a3b8;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.tab-btn.active {
  color: #e11d48;
  border-bottom-color: #e11d48;
}

.tab-btn:hover {
  color: #475569;
}

.doc-tag {
  background: #eff6ff;
  color: #2563eb;
}

.history-kirim td { background: #f0fdf4; }
.history-chiqim td { background: #fff5f5; }

.sales-table-wrap {
  padding: 10px;
  max-height: 500px;
  overflow-y: auto;
}

.detail-row td {
  background: #fafbff;
  padding: 0 !important;
  border-bottom: 2px solid #e2e8f0;
}
.detail-container {
  padding: 14px 18px;
}
.detail-section {
  margin-bottom: 14px;
}
.detail-section:last-child { margin-bottom: 0; }
.detail-section-title {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e2e8f0;
}
.detail-section-title.purple { color: #a142f4; }
.detail-section-title.blue { color: #2563eb; }
.inner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}
.inner-table thead th {
  background: #f1f5f9;
  padding: 8px 10px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
}
.inner-table tbody td {
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}
.inner-table tbody tr:last-child td { border-bottom: none; }
.empty-detail {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
  font-style: italic;
  font-size: 13px;
}

/* PAY MODAL */
.pay-modal {
  background: white;
  border-radius: 24px;
  width: 520px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
}

.pay-info {
  padding: 16px 25px;
  background: #f8fafc;
}

.pay-info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
}

.info-label {
  color: #94a3b8;
  margin-right: 4px;
}

.pay-form {
  padding: 20px 25px;
}

.method-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.pay-field {
  margin-bottom: 12px;
  position: relative;
}

.pay-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.pay-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  outline: none;
}

.pay-input:focus {
  border-color: #e11d48;
  box-shadow: 0 0 0 3px rgba(225,29,72,0.1);
}

.target-toggle {
  display: flex;
  gap: 8px;
}
.toggle-btn {
  flex: 1;
  height: 40px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s;
}
.toggle-btn.active {
  background: #e11d48;
  border-color: #e11d48;
  color: white;
}

.conversion-note {
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #b45309;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
}

.pay-total-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0 0;
  margin-top: 8px;
  border-top: 2px solid #e2e8f0;
  font-size: 16px;
}

/* QUICK ACTIONS — lahtak universal yopish */
.quick-actions {
  background: linear-gradient(135deg, #faf5ff 0%, #f5f3ff 100%);
  border: 1.5px dashed #c4b5fd;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 12px;
}
.qa-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 8px;
}
.qa-label svg { color: #a142f4; }
.qa-label b.red { color: #e11d48; }
.qa-label b.green { color: #059669; }
.qa-btns {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.qa-btn {
  border: 1px solid transparent;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: 0.15s;
}
.qa-btn:hover { transform: translateY(-1px); box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
.qa-primary {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}
.qa-soft {
  background: white;
  color: #a142f4;
  border-color: #ddd6fe;
}
.qa-soft:hover { background: #a142f4; color: white; border-color: #a142f4; }
.qa-clear {
  background: #fff1f2;
  color: #e11d48;
  width: 32px;
  padding: 6px;
  justify-content: center;
}
.qa-clear:hover { background: #e11d48; color: white; }

.pay-actions {
  display: flex;
  gap: 12px;
  padding: 0 25px 20px;
}

.m-btn {
  flex: 1;
  padding: 13px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.cancel  { background: #f1f5f9; color: #64748b; }

.pay-confirm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}
.pay-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.debt-confirm {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}
.debt-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* MIJOZ TANLASH DROPDOWN */
.customer-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  max-height: 220px;
  overflow-y: auto;
  z-index: 20;
  margin-top: 4px;
}
.customer-option {
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
}
.customer-option:hover { background: #f8fafc; }
.locked-customer {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background: #f1f5f9;
  border-radius: 10px;
  font-weight: 700;
  color: #1e293b;
}
</style>
